import { render, staticRenderFns } from "./ContentCard.vue?vue&type=template&id=8f4edcb6&scoped=true&"
import script from "./ContentCard.vue?vue&type=script&lang=ts&"
export * from "./ContentCard.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCard.vue?vue&type=style&index=0&id=8f4edcb6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4edcb6",
  null
  
)

export default component.exports